import AuthLayout from '../layouts/AuthLayout.vue'

export default {
  path: '/',
  name: 'authorization',
  component: AuthLayout,
  redirect: {
    name: 'auth.login',
  },
  children: [
    {
      path: '/login',
      name: 'auth.login',
      component: () => import('@/views/AuthView.vue'),
      meta: {
        title: 'Sign in',
      },
    },
    {
      path: '/reset-password',
      name: 'auth.reset-password',
      component: () => import('@/views/auth/PasswordResetForm.vue'),
      meta: {
        title: 'Sign in',
      },
    },
  ],
}
